import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const FooterServices = () => {
  const { t } = useLanguage();
  const items = [
    t.services?.ecommerce?.title,
    t.services?.performance?.title,
    t.services?.analysis?.title,
    t.services?.branding?.title
  ];

  return (
    <div>
      <h3 className="text-white font-semibold mb-4">{t.services?.title}</h3>
      <ul className="space-y-2 text-sm">
        {items.map((label) => (
          <li key={label} className="text-gray-400">{label}</li>
        ))}
      </ul>
    </div>
  );
};

export default FooterServices;
